import { LayoutComponent } from "@jelly/lesson";

import audibility_test_1 from "./audibility-test/audibility-test-1";
import audibility_test_2 from "./audibility-test/audibility-test-2";
import audibility_test_3 from "./audibility-test/audibility-test-3";
import audibility_test_4 from "./audibility-test/audibility-test-4";
import audibility_test_5 from "./audibility-test/audibility-test-5";
import audibility_test_6 from "./audibility-test/audibility-test-6";
import audibility_test_7 from "./audibility-test/audibility-test-7";
import audibility_test_8 from "./audibility-test/audibility-test-8";
import audibility_test_9 from "./audibility-test/audibility-test-9";
import audibility_test_10 from "./audibility-test/audibility-test-10";
import audibility_test_11 from "./audibility-test/audibility-test-11";
import audibility_test_12 from "./audibility-test/audibility-test-12";
import audibility_test_13 from "./audibility-test/audibility-test-13";
import audibility_test_14 from "./audibility-test/audibility-test-14";
import audibility_test_15 from "./audibility-test/audibility-test-15";
import audibility_test_16 from "./audibility-test/audibility-test-16";
import audibility_test_17 from "./audibility-test/audibility-test-17";
import audibility_test_18 from "./audibility-test/audibility-test-18";
import audibility_test_19 from "./audibility-test/audibility-test-19";
import audibility_test_20 from "./audibility-test/audibility-test-20";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 15],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>audibilitiy test (check for visibility) for image sources</b>",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    textTransform: "uppercase",
                    fontSize: "14px",
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "carouselPaginated",
              options: {
                components: [
                  audibility_test_1,
                  audibility_test_2,
                  audibility_test_3,
                  audibility_test_4,
                  audibility_test_5,
                  audibility_test_6,
                  audibility_test_7,
                  audibility_test_8,
                  audibility_test_9,
                  audibility_test_10,
                  audibility_test_11,
                  audibility_test_12,
                  audibility_test_13,
                  audibility_test_14,
                  audibility_test_15,
                  audibility_test_16,
                  audibility_test_17,
                  audibility_test_18,
                  audibility_test_19,
                  audibility_test_20,
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
